export interface ByteSource {
  readonly size: number;
  read(offset: number, length: number): Promise<Uint8Array>;
}

export const blobSource = (blob: Blob): ByteSource => ({
  size: blob.size,
  read: async (offset, length) => new Uint8Array(await blob.slice(offset, offset + length).arrayBuffer()),
});

export const viewOf = (bytes: Uint8Array): DataView => new DataView(bytes.buffer, bytes.byteOffset, bytes.byteLength);

export const u64 = (view: DataView, offset: number): number =>
  view.getUint32(offset) * 2 ** 32 + view.getUint32(offset + 4);

export const i64 = (view: DataView, offset: number): number =>
  view.getInt32(offset) * 2 ** 32 + view.getUint32(offset + 4);

export const fourcc = (view: DataView, offset: number): string =>
  String.fromCharCode(
    view.getUint8(offset),
    view.getUint8(offset + 1),
    view.getUint8(offset + 2),
    view.getUint8(offset + 3),
  );
